<template>
  <div class="pc">
    <div class="pcLogo"><img :src="obj?.logo" alt="" class="pcLogoImg" /></div>
    <img :src="obj?.banner" alt="" class="pcBanner" />
    <img :src="obj?.overview" alt="" class="pcOverview" />
    <img :src="obj?.process" alt="" class="pcProcess" />
    <img :src="obj?.highlight" alt="" class="pcHighlight" />
    <div class="pcSignup">
      <img :src="obj?.signupTitle" alt="" class="pcSignupTitle" />
      <div class="pcSignupTrack">
        <div v-for="(item, index) in obj?.track" class="pcSignupTrackItem">
          <img :src="item.photo" alt="" class="pcSignupTrackItemImg" />
          <img @click="jump(item.id)" src="https://p2.ssl.qhimg.com/t11b673bcd602dd1143fe200b7a.png" alt="" class="pcSignupTrackItemBtn">
        </div>
      </div>
      <img :src="obj?.detail" alt="" class="pcSignupDetail" />
    </div>
    <img :src="obj?.expertImg" alt="" class="pcExpert">
    <!-- <div class="pcExpert">
      <img :src="obj?.expertTitle" alt="" class="pcExpertTitle" />
      <div class="expert">
        <div class="expertLeader">
          <img :src="obj?.leader?.photo" alt="" class="expertLeaderImg" />
          <div class="expertLeaderName">{{ obj?.leader?.name }}</div>
          <div class="expertLeaderJob">{{ obj?.leader?.job }}</div>
        </div>
        <div class="expertGroup">
          <div v-for="(item, index) in obj?.expertArr" :key="index" class="expertGroupItem">
            <img :src="item.photo" alt="" class="expertGroupItemImg" />
            <div class="expertGroupItemName">{{ item.name }}</div>
            <div class="expertGroupItemJob">{{ item.job }}</div>
          </div>
        </div>
      </div>
    </div> -->
    <img :src="obj?.org" alt="" class="pcOrg">
  </div>
</template>

<script setup>
import { ref, onBeforeMount, onMounted, onUnmounted } from 'vue'
import { getRecruit } from '@/api/2024/index'

// let obj = ref({
//   logo: 'https://p5.ssl.qhimg.com/t11b673bcd6520b9656fdda65e7.png',
//   banner: 'https://p3.ssl.qhimg.com/t11b673bcd65934b000d4614aee.png',
//   overview: 'https://p4.ssl.qhimg.com/t11b673bcd693abaf56a1b11781.png',
//   process: 'https://p3.ssl.qhimg.com/t11b673bcd698fc35f7bb41e77e.png',
//   highlight: 'https://p3.ssl.qhimg.com/t11b673bcd6998c2952e54f7133.png',
//   signupTitle: 'https://p0.ssl.qhimg.com/t11b673bcd6a374a628bdca6aad.png',
//   track: [
//     {
//       photo: 'https://p5.ssl.qhimg.com/t11b673bcd6d42961cef3e33376.png',
//       id: 'safe'
//     },
//     {
//       photo: 'https://p5.ssl.qhimg.com/t11b673bcd68f22a238eebf788b.png',
//       id: 'ai'
//     },
//     {
//       photo: 'https://p0.ssl.qhimg.com/t11b673bcd60f03cdd26a52bc11.png',
//       id: 'isc'
//     }
//   ],
//   detail: 'https://p0.ssl.qhimg.com/t11b673bcd6da6e6f7b025b8291.png',
//   expertTitle: 'https://p5.ssl.qhimg.com/t11b673bcd60eb98b9945a6644a.png',
//   // leader: {
//   //   name: '周鸿祎',
//   //   job: '360集团创始人',
//   //   photo: 'https://p0.ssl.qhimg.com/t11b673bcd6a5646a206a5abb59.png'
//   // },
//   // expertArr: [
//   //   {
//   //     name: '国秀娟',
//   //     job: 'BP商业伙伴创始人兼总裁',
//   //     photo: 'https://p3.ssl.qhimg.com/t11b673bcd68d45e0fa763fdaba.png'
//   //   },
//   //   {
//   //     name: '国秀娟',
//   //     job: 'BP商业伙伴创始人兼总裁',
//   //     photo: 'https://p3.ssl.qhimg.com/t11b673bcd68d45e0fa763fdaba.png'
//   //   },
//   //   {
//   //     name: '国秀娟',
//   //     job: 'BP商业伙伴创始人兼总裁',
//   //     photo: 'https://p3.ssl.qhimg.com/t11b673bcd68d45e0fa763fdaba.png'
//   //   },
//   //   {
//   //     name: '国秀娟',
//   //     job: 'BP商业伙伴创始人兼总裁',
//   //     photo: 'https://p3.ssl.qhimg.com/t11b673bcd68d45e0fa763fdaba.png'
//   //   },
//   //   {
//   //     name: '国秀娟',
//   //     job: 'BP商业伙伴创始人兼总裁',
//   //     photo: 'https://p3.ssl.qhimg.com/t11b673bcd68d45e0fa763fdaba.png'
//   //   },
//   //   {
//   //     name: '国秀娟',
//   //     job: 'BP商业伙伴创始人兼总裁',
//   //     photo: 'https://p3.ssl.qhimg.com/t11b673bcd68d45e0fa763fdaba.png'
//   //   },
//   //   {
//   //     name: '国秀娟',
//   //     job: 'BP商业伙伴创始人兼总裁',
//   //     photo: 'https://p3.ssl.qhimg.com/t11b673bcd68d45e0fa763fdaba.png'
//   //   },
//   //   {
//   //     name: '国秀娟',
//   //     job: 'BP商业伙伴创始人兼总裁',
//   //     photo: 'https://p3.ssl.qhimg.com/t11b673bcd68d45e0fa763fdaba.png'
//   //   },
//   //   {
//   //     name: '国秀娟',
//   //     job: 'BP商业伙伴创始人兼总裁',
//   //     photo: 'https://p3.ssl.qhimg.com/t11b673bcd68d45e0fa763fdaba.png'
//   //   },
//   //   {
//   //     name: '国秀娟',
//   //     job: 'BP商业伙伴创始人兼总裁',
//   //     photo: 'https://p3.ssl.qhimg.com/t11b673bcd68d45e0fa763fdaba.png'
//   //   },
//   //   {
//   //     name: '国秀娟',
//   //     job: 'BP商业伙伴创始人兼总裁',
//   //     photo: 'https://p3.ssl.qhimg.com/t11b673bcd68d45e0fa763fdaba.png'
//   //   },
//   //   {
//   //     name: '国秀娟',
//   //     job: 'BP商业伙伴创始人兼总裁',
//   //     photo: 'https://p3.ssl.qhimg.com/t11b673bcd68d45e0fa763fdaba.png'
//   //   }
//   // ],
//   expertImg: 'https://p0.ssl.qhimg.com/t11b673bcd66ade60ff8c6b151b.png',
//   org: 'https://p5.ssl.qhimg.com/t11b673bcd64e5f7aff07ac6bd5.png'
// })
let obj = ref({})
onBeforeMount(async () => {
  await fetch()
})
function jump(id) {
  if(id === 'isc') {
    window.open('https://agent.360.cn/contest.html','_blank')
  } else {
    window.open('https://isc.360.com/2024/info/login.html', '_blank')
  }
}

function fetch() {
  getRecruit('QnZtWWxnSnJjL0hkS2czamV3YkVFUT09Ojp1NhwBFqVZRMPIRLYcQ7H5')
    .then((res) => {
      let result = JSON.parse(res.data.data.data)
      // console.log('res', result)
      obj.value = result
    })
    .catch(() => {})
}
</script>

<style lang="scss" scoped>
.pc {
  width: 100%;
  &Logo {
    width: 993px;
    height: 77px;
    margin: 0 auto;
    &Img {
      width: 143px;
      height: 40px;
      margin-top: 20px;
    }
  }
  &Banner {
    width: 100%;
    display: block;
  }
  &Overview {
    width: 956px;
    margin: 78px auto 128px;
    display: block;
  }
  &Process {
    width: 1200px;
    margin: 0 auto 128px;
    display: block;
  }
  &Highlight {
    width: 1199px;
    margin: 0 auto 128px;
    display: block;
  }
  &Signup {
    width: 1186px;
    margin: 0 auto 143px;
    display: block;
    // background-color: pink;
    &Title {
      width: 842px;
      margin: 0 auto 56px;
      display: block;
    }
    &Track {
      display: flex;
      justify-content: space-between;
      margin-bottom: 60px;
      &Item {
        width: 380px;
        position: relative;
        &Img {
          width: 380px;
        }
        &Btn {
          position: absolute;
          bottom: 38px;
    left: 50%;
    transform: translateX(-50%);
          cursor: pointer;
          width: 150px;
        }
      }
    }
    &Detail {
      width: 1094px;
      margin: 0 auto;
      display: block;
    }
  }
  // &Expert {
  //   width: 1094px;
  //   margin: 0 auto 126px;
  //   &Title {
  //     width: 842px;
  //     margin: 0 auto 87px;
  //     display: block;
  //   }
  // }
  &Expert {
    display: block;
    margin: 0 auto 126px;
    width: 1092px;
  }
  &Org {
    width: 1098px;
    margin: 0 auto 202px;
    display: block;
  }
}
.expert {
  margin: 0 36px 0;
  // background-color: pink;
  &Leader {
    margin: 0 auto 47px;
    width: 180px;
    &Img {
      width: 128px;
      display: block;
      margin: 0 auto;
    }
    &Name {
      margin: 20px auto 10px;
      color: rgb(0, 0, 0);
      font-size: 20px;
      font-weight: 700;
      line-height: 20px;
      letter-spacing: 0px;
      text-align: center;
    }
    &Job {
      color: rgb(0, 0, 0);
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      letter-spacing: 0px;
      text-align: center;
    }
  }
  &Group {
    display: flex;
    gap: 69px 58px;
    flex-wrap: wrap;
    &Item {
      &Img {
        width: 128px;
        display: block;
        margin: 0 auto;
      }
      &Name {
        margin: 20px auto 10px;
        color: rgb(0, 0, 0);
        font-size: 20px;
        font-weight: 700;
        line-height: 20px;
        letter-spacing: 0px;
        text-align: center;
      }
      &Job {
        color: rgb(0, 0, 0);
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        letter-spacing: 0px;
        text-align: center;
      }
    }
  }
}
</style>
